import React, { useState } from "react";
import { supabase } from "../supabaseClient";
import axios from "axios";
import toast from "react-hot-toast";
import { API_URL } from "../config";

// ─── Proje standart koyu tema paleti (HacimProfiliTarama.jsx referansı) ─────
const C = {
    bg: "#0f172a", panel: "#1e293b", border: "#334155", text: "#e2e8f0",
    muted: "#94a3b8", accent: "#3b82f6", bullish: "#16a34a", bearish: "#dc2626",
    warning: "#f59e0b",
};

const MODUL_ETIKET = {
    karar_motoru: "Karar Motoru",
    puanlama_tahmin: "Puanlama & Tahmin",
    birlesik_skor: "Birleşik Skor",
};

const farkRenk = (fark) => {
    if (fark == null) return C.muted;
    const a = Math.abs(fark);
    if (a <= 5) return "#22c55e";      // iyi kalibre
    if (a <= 15) return "#eab308";     // orta sapma
    return "#ef4444";                  // ciddi yanıltıcı
};

// ─── Terim açıklamaları (kolon başlıklarındaki "i" ikonunda gösterilir) ──────
const TERIM_ACIKLAMA = {
    skor_bandi: "Sinyalin kaydedildiği andaki güven skorunun düştüğü 10'luk aralık (ör. 80-90). Aynı bantta biriken tüm sinyaller birlikte değerlendirilir.",
    sinyal: "O bantta, sonucu netleşmiş (kazandı/kaybetti belli olmuş — henüz açık olanlar hariç) toplam sinyal sayısı. Örneklem küçükse (<15) 'az örneklem' uyarısı görünür.",
    gerceklesen_pct: "O banttaki sinyallerin GERÇEKTE kazanma oranı (kazanan / toplam × 100). Modülün vaat ettiği skor değil, fiyat hareketinden ölçülen gerçek sonuç.",
    kalibrasyon_farki: "Skor bandının ortası (ör. 80-90 için 85) eksi Gerçekleşen %. Pozitif ve büyükse skor OLDUĞUNDAN FAZLA güven veriyor demektir (ör. +30 → skor 85 diyor ama gerçekte %55 kazanıyor).",
};

// ─── "i" ikonu — üzerine gelince aşağı doğru açıklama penceresi açar ─────────
function BilgiIkonu({ metin }) {
    const [acik, setAcik] = useState(false);
    return (
        <span
            style={{ position: "relative", display: "inline-block", marginLeft: "5px" }}
            onMouseEnter={() => setAcik(true)}
            onMouseLeave={() => setAcik(false)}
        >
            <span style={{
                display: "inline-flex", alignItems: "center", justifyContent: "center",
                width: "14px", height: "14px", borderRadius: "50%",
                background: C.border, color: C.muted, fontSize: "10px", fontWeight: 700,
                fontStyle: "italic", cursor: "help", userSelect: "none",
            }}>i</span>

            {acik && (
                <div style={{
                    position: "absolute", top: "calc(100% + 8px)", left: "50%",
                    transform: "translateX(-50%)", width: "230px", zIndex: 50,
                    background: "#0b1220", border: `1px solid ${C.border}`, borderRadius: "8px",
                    padding: "9px 11px", fontSize: "11px", fontWeight: 400, color: C.text,
                    lineHeight: "1.55", boxShadow: "0 10px 28px rgba(0,0,0,0.45)",
                    textTransform: "none", whiteSpace: "normal",
                }}>
                    {metin}
                    {/* Ok işareti */}
                    <div style={{
                        position: "absolute", bottom: "100%", left: "50%", transform: "translateX(-50%)",
                        width: 0, height: 0, borderLeft: "6px solid transparent",
                        borderRight: "6px solid transparent", borderBottom: "6px solid #0b1220",
                    }} />
                </div>
            )}
        </span>
    );
}

export default function KalibrasyonPaneli() {
    const [piyasa, setPiyasa] = useState("Tümü");
    const [minGun, setMinGun] = useState(30);
    const [yukleniyor, setYukleniyor] = useState(false);
    const [rapor, setRapor] = useState(null);
    const [hata, setHata] = useState("");

    const getToken = async () => {
        const { data: { session } } = await supabase.auth.getSession();
        return session?.access_token;
    };

    const calistir = async () => {
        setYukleniyor(true); setHata("");
        try {
            const params = { min_gun: minGun };
            if (piyasa !== "Tümü") params.mod = piyasa;
            const token = await getToken();
            const res = await axios.get(`${API_URL}/scan/kalibrasyon-raporu`, {
                params,
                headers: { Authorization: `Bearer ${token}` },
            });
            setRapor(res.data);
            if (!res.data?.bantlar?.length) toast("Henüz yeterli kapanmış sinyal yok.");
        } catch (e) {
            setHata(e?.response?.data?.detail || "Rapor alınamadı.");
            toast.error("Kalibrasyon raporu alınamadı.");
        } finally {
            setYukleniyor(false);
        }
    };

    const satirlar = rapor?.bantlar || [];

    // ── Sonuç listesi filtreleri (client-side, HacimProfiliTarama.jsx ile aynı Set+pill deseni) ──
    const [fModul, setFModul] = useState(new Set());
    const [fPiyasa, setFPiyasa] = useState(new Set());
    const [fVade, setFVade] = useState(new Set());
    const [fSkorBandi, setFSkorBandi] = useState(new Set());
    const [fSonuc, setFSonuc] = useState(new Set()); // "Kazanan Ağırlıklı" | "Kaybeden Ağırlıklı" | "Eşit"

    const toggleF = (setter) => (v) => setter(prev => {
        const s = new Set(prev);
        s.has(v) ? s.delete(v) : s.add(v);
        return s;
    });
    const toggleFModul = toggleF(setFModul);
    const toggleFPiyasa = toggleF(setFPiyasa);
    const toggleFVade = toggleF(setFVade);
    const toggleFSkorBandi = toggleF(setFSkorBandi);
    const toggleFSonuc = toggleF(setFSonuc);

    const vadeSecenekleri = [...new Set(satirlar.map(r => r.vade))].sort();
    const skorBandiSecenekleri = [...new Set(satirlar.map(r => r.skor_bandi))]
        .sort((a, b) => parseInt(a) - parseInt(b));

    const filtreliSatirlar = satirlar.filter(r => {
        if (fModul.size > 0 && !fModul.has(r.modul)) return false;
        if (fPiyasa.size > 0 && !fPiyasa.has(r.mod)) return false;
        if (fVade.size > 0 && !fVade.has(r.vade)) return false;
        if (fSkorBandi.size > 0 && !fSkorBandi.has(r.skor_bandi)) return false;
        if (fSonuc.size > 0) {
            const eslesti = [...fSonuc].some(v => {
                if (v === "Kazanan Ağırlıklı") return r.kazanan > r.kaybeden;
                if (v === "Kaybeden Ağırlıklı") return r.kaybeden > r.kazanan;
                if (v === "Eşit") return r.kazanan === r.kaybeden;
                return false;
            });
            if (!eslesti) return false;
        }
        return true;
    });

    const filtreAktif = fModul.size > 0 || fPiyasa.size > 0 || fVade.size > 0 ||
        fSkorBandi.size > 0 || fSonuc.size > 0;
    const filtreleriTemizle = () => {
        setFModul(new Set()); setFPiyasa(new Set()); setFVade(new Set());
        setFSkorBandi(new Set()); setFSonuc(new Set());
    };

    return (
        <div style={{ background: C.bg, minHeight: "100vh", padding: "24px", color: C.text }}>
            <h2 style={{ margin: 0, fontSize: "20px", fontWeight: 700 }}>🎯 Kalibrasyon Paneli</h2>
            <p style={{ color: C.muted, fontSize: "13px", marginTop: "6px", maxWidth: "720px" }}>
                Güven skoru ile gerçekleşen başarı oranını karşılaştırır. "Kalibrasyon Farkı" ne kadar
                büyükse, o skor bandındaki güven o kadar yanıltıcı demektir (skor bandı ortası − gerçekleşen %).
            </p>

            {/* Filtre kartı */}
            <div style={{
                background: C.panel, border: `1px solid ${C.border}`, borderRadius: "12px",
                padding: "16px", marginTop: "18px", display: "flex", gap: "16px",
                alignItems: "flex-end", flexWrap: "wrap",
            }}>
                <div>
                    <div style={{ fontSize: "12px", color: C.muted, marginBottom: "6px" }}>Piyasa</div>
                    <div style={{ display: "flex", gap: "6px" }}>
                        {["Tümü", "BIST", "Kripto"].map(p => (
                            <button key={p} onClick={() => setPiyasa(p)} style={{
                                padding: "6px 14px", borderRadius: "8px", cursor: "pointer",
                                border: `1px solid ${piyasa === p ? C.accent : C.border}`,
                                background: piyasa === p ? C.accent : "transparent",
                                color: piyasa === p ? "white" : C.text, fontSize: "13px",
                            }}>{p}</button>
                        ))}
                    </div>
                </div>

                <div>
                    <div style={{ fontSize: "12px", color: C.muted, marginBottom: "6px" }}>
                        Min. Geçmiş Gün (sinyalin en az kaç gün önce kaydedilmiş olması gerekli)
                    </div>
                    <select value={minGun} onChange={e => setMinGun(Number(e.target.value))} style={{
                        padding: "6px 10px", borderRadius: "8px", border: `1px solid ${C.border}`,
                        background: "transparent", color: C.text, fontSize: "13px",
                    }}>
                        {[7, 14, 30, 60, 90].map(g => <option key={g} value={g} style={{ color: "#000" }}>{g} gün</option>)}
                    </select>
                </div>

                <button onClick={calistir} disabled={yukleniyor} style={{
                    padding: "8px 20px", borderRadius: "8px", border: "none",
                    background: yukleniyor ? "#475569" : C.accent, color: "white",
                    cursor: yukleniyor ? "default" : "pointer", fontSize: "13px", fontWeight: 600,
                }}>
                    {yukleniyor ? "Hesaplanıyor…" : "Raporu Oluştur"}
                </button>
            </div>

            {hata && (
                <div style={{ marginTop: "14px", color: "#ef4444", fontSize: "13px" }}>{hata}</div>
            )}

            {rapor && (
                <div style={{ marginTop: "10px", fontSize: "12px", color: C.muted }}>
                    Oluşturulma: {rapor.olusturuldu_at} · Pencere: {rapor.max_pencere_gun} gün ·
                    Min. örneklem eşiği: {rapor.min_orneklem_esigi}
                </div>
            )}

            {/* Sonuç Filtre Kartı — HacimProfiliTarama.jsx ile aynı desen */}
            {satirlar.length > 0 && (
                <div style={{
                    background: C.panel, border: `1px solid ${C.border}`, borderRadius: 12,
                    padding: "12px 20px", marginTop: "18px", display: "flex", gap: 12,
                    flexWrap: "wrap", alignItems: "center",
                }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <span style={{ fontSize: 11, fontWeight: 700, color: C.muted, letterSpacing: "0.05em", whiteSpace: "nowrap" }}>MODÜL</span>
                        {Object.entries(MODUL_ETIKET).map(([v, label]) => {
                            const aktif = fModul.has(v);
                            return (
                                <button key={v} onClick={() => toggleFModul(v)} style={{
                                    padding: "4px 10px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                    fontWeight: aktif ? 700 : 400,
                                    border: `2px solid ${aktif ? C.accent : C.border}`,
                                    background: aktif ? C.accent + "22" : "transparent",
                                    color: aktif ? C.accent : C.muted,
                                }}>{label}</button>
                            );
                        })}
                    </div>

                    <div style={{ width: 1, height: 20, background: C.border }} />
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <span style={{ fontSize: 11, fontWeight: 700, color: C.muted, letterSpacing: "0.05em", whiteSpace: "nowrap" }}>PİYASA</span>
                        {["BIST", "Kripto"].map(v => {
                            const aktif = fPiyasa.has(v);
                            return (
                                <button key={v} onClick={() => toggleFPiyasa(v)} style={{
                                    padding: "4px 10px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                    fontWeight: aktif ? 700 : 400,
                                    border: `2px solid ${aktif ? C.accent : C.border}`,
                                    background: aktif ? C.accent + "22" : "transparent",
                                    color: aktif ? C.accent : C.muted,
                                }}>{v}</button>
                            );
                        })}
                    </div>

                    <div style={{ width: 1, height: 20, background: C.border }} />
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <span style={{ fontSize: 11, fontWeight: 700, color: C.muted, letterSpacing: "0.05em", whiteSpace: "nowrap" }}>VADE</span>
                        {vadeSecenekleri.map(v => {
                            const aktif = fVade.has(v);
                            return (
                                <button key={v} onClick={() => toggleFVade(v)} style={{
                                    padding: "4px 10px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                    fontWeight: aktif ? 700 : 400,
                                    border: `2px solid ${aktif ? C.accent : C.border}`,
                                    background: aktif ? C.accent + "22" : "transparent",
                                    color: aktif ? C.accent : C.muted,
                                }}>{v}</button>
                            );
                        })}
                    </div>

                    <div style={{ width: 1, height: 20, background: C.border }} />
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <span style={{ fontSize: 11, fontWeight: 700, color: C.muted, letterSpacing: "0.05em", whiteSpace: "nowrap" }}>SKOR BANDI</span>
                        {skorBandiSecenekleri.map(v => {
                            const aktif = fSkorBandi.has(v);
                            return (
                                <button key={v} onClick={() => toggleFSkorBandi(v)} style={{
                                    padding: "4px 10px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                    fontWeight: aktif ? 700 : 400,
                                    border: `2px solid ${aktif ? C.accent : C.border}`,
                                    background: aktif ? C.accent + "22" : "transparent",
                                    color: aktif ? C.accent : C.muted,
                                }}>{v}</button>
                            );
                        })}
                    </div>

                    <div style={{ width: 1, height: 20, background: C.border }} />
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <span style={{ fontSize: 11, fontWeight: 700, color: C.muted, letterSpacing: "0.05em", whiteSpace: "nowrap" }}>KAZANAN / KAYBEDEN</span>
                        {[
                            { v: "Kazanan Ağırlıklı", r: C.bullish },
                            { v: "Kaybeden Ağırlıklı", r: C.bearish },
                            { v: "Eşit", r: C.muted },
                        ].map(opt => {
                            const aktif = fSonuc.has(opt.v);
                            return (
                                <button key={opt.v} onClick={() => toggleFSonuc(opt.v)} style={{
                                    padding: "4px 10px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                    fontWeight: aktif ? 700 : 400,
                                    border: `2px solid ${aktif ? opt.r : C.border}`,
                                    background: aktif ? opt.r + "22" : "transparent",
                                    color: aktif ? opt.r : C.muted,
                                }}>{opt.v}</button>
                            );
                        })}
                    </div>

                    <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 10 }}>
                        <span style={{ fontSize: 12, color: C.muted }}>
                            <strong style={{ color: C.text }}>{filtreliSatirlar.length}</strong>{" / "}{satirlar.length} sonuç
                        </span>
                        {filtreAktif && (
                            <button onClick={filtreleriTemizle} style={{
                                padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                border: `1px solid ${C.bearish}66`, background: C.bearish + "11", color: C.bearish,
                            }}>✕ Temizle</button>
                        )}
                    </div>
                </div>
            )}

            {/* Sonuç tablosu */}
            {filtreliSatirlar.length > 0 && (
                <div style={{
                    marginTop: "18px", border: `1px solid ${C.border}`, borderRadius: "12px",
                    overflow: "visible",
                }}>
                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
                        <thead>
                            <tr style={{ background: "#152033" }}>
                                {["Modül", "Piyasa", "Vade"].map(h => (
                                    <th key={h} style={{
                                        textAlign: "left", padding: "10px 12px", color: C.muted,
                                        fontWeight: 600, borderBottom: `1px solid ${C.border}`,
                                    }}>{h}</th>
                                ))}
                                <th style={{ textAlign: "left", padding: "10px 12px", color: C.muted, fontWeight: 600, borderBottom: `1px solid ${C.border}` }}>
                                    Skor Bandı<BilgiIkonu metin={TERIM_ACIKLAMA.skor_bandi} />
                                </th>
                                <th style={{ textAlign: "left", padding: "10px 12px", color: C.muted, fontWeight: 600, borderBottom: `1px solid ${C.border}` }}>
                                    Sinyal<BilgiIkonu metin={TERIM_ACIKLAMA.sinyal} />
                                </th>
                                {["Kazanan", "Kaybeden"].map(h => (
                                    <th key={h} style={{
                                        textAlign: "left", padding: "10px 12px", color: C.muted,
                                        fontWeight: 600, borderBottom: `1px solid ${C.border}`,
                                    }}>{h}</th>
                                ))}
                                <th style={{ textAlign: "left", padding: "10px 12px", color: C.muted, fontWeight: 600, borderBottom: `1px solid ${C.border}` }}>
                                    Gerçekleşen %<BilgiIkonu metin={TERIM_ACIKLAMA.gerceklesen_pct} />
                                </th>
                                <th style={{ textAlign: "left", padding: "10px 12px", color: C.muted, fontWeight: 600, borderBottom: `1px solid ${C.border}` }}>
                                    Kalibrasyon Farkı<BilgiIkonu metin={TERIM_ACIKLAMA.kalibrasyon_farki} />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtreliSatirlar.map((r, i) => (
                                <tr key={i} style={{ borderBottom: `1px solid ${C.border}` }}>
                                    <td style={{ padding: "9px 12px" }}>{MODUL_ETIKET[r.modul] || r.modul}</td>
                                    <td style={{ padding: "9px 12px" }}>{r.mod}</td>
                                    <td style={{ padding: "9px 12px" }}>{r.vade}</td>
                                    <td style={{ padding: "9px 12px", fontWeight: 600 }}>{r.skor_bandi}</td>
                                    <td style={{ padding: "9px 12px" }}>
                                        {r.toplam_sinyal}
                                        {r.orneklem_yetersiz && (
                                            <span style={{
                                                marginLeft: "6px", fontSize: "10px", color: "#eab308",
                                                border: "1px solid #eab308", borderRadius: "6px", padding: "1px 6px",
                                            }}>az örneklem</span>
                                        )}
                                    </td>
                                    <td style={{ padding: "9px 12px", color: "#22c55e" }}>{r.kazanan}</td>
                                    <td style={{ padding: "9px 12px", color: "#ef4444" }}>{r.kaybeden}</td>
                                    <td style={{ padding: "9px 12px", fontWeight: 600 }}>
                                        {r.gerceklesen_basari_pct != null ? `%${r.gerceklesen_basari_pct}` : "—"}
                                    </td>
                                    <td style={{ padding: "9px 12px", fontWeight: 700, color: farkRenk(r.kalibrasyon_farki) }}>
                                        {r.kalibrasyon_farki != null ? `${r.kalibrasyon_farki > 0 ? "+" : ""}${r.kalibrasyon_farki}` : "—"}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {satirlar.length > 0 && filtreliSatirlar.length === 0 && (
                <div style={{ marginTop: "18px", color: C.muted, fontSize: "13px" }}>
                    Seçili filtrelerle eşleşen satır yok.
                </div>
            )}

            {rapor && satirlar.length === 0 && !hata && (
                <div style={{ marginTop: "18px", color: C.muted, fontSize: "13px" }}>
                    Bu filtrelerle henüz kapanmış (kazandı/kaybetti sonucu netleşmiş) sinyal bulunamadı.
                </div>
            )}
        </div>
    );
}
